import { DriverType, FieldsEnum, FormsEnum } from 'app/shared/enums';
import {
  getFirstCoownerData,
  getQuotation,
  getQuotationIsFromRenewal,
  setDataOwnersChangedRenewal,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import {
  BusinessFunctionsService,
  setNoDriverLicenseFieldsVisibility,
} from 'app/services/businessFunctions.service';
import { setBirthdateAndGenderByPesel } from 'app/services/businessFunctions/helpers/setBirthdateAndGenderByPesel';
import { setFamilyNameVisibility } from 'app/services/businessFunctions/helpers/setFamilyNameVisibility';
import { isPeselValid, stringifyPesel } from 'app/services/pesel.service';
import { getMessageKeyWithSuffix } from 'app/services/validation.service';
import { checkHasDataChangedForRenewal } from 'app/services/businessFunctions/helpers/checkHasDataChangedForRenewal';
import { setMainOwnerSelectionDictionary } from 'app/shared/helpers/setMainOwnerSelectionDictionary';

const firstCoownerDetails = {
  firstCoownerPeselChange(initialRun: boolean) {
    const { coOwners } = getQuotation();
    const isFromRenewal = getQuotationIsFromRenewal();
    const { pesel } = getFirstCoownerData();
    const previousPesel = coOwners?.[0]?.peselNumber || '';
    const isValidPesel = isPeselValid(stringifyPesel(pesel));

    if (initialRun) {
      setMessageVisibility({
        formName: FormsEnum.CalculationForm,
        key: getMessageKeyWithSuffix(
          FieldsEnum.Coowners1Pesel,
          'invalid_pesel'
        ),
        visible: false,
      });

      setMessageVisibility({
        formName: FormsEnum.CalculationForm,
        key: getMessageKeyWithSuffix(
          FieldsEnum.Coowners1Pesel,
          'too_young_owner_pesel'
        ),
        visible: false,
      });
    }

    setBirthdateAndGenderByPesel(
      initialRun,
      pesel as number,
      FormsEnum.CalculationForm,
      FieldsEnum.Coowners1BirthDate,
      FieldsEnum.Coowners1Gender
    );

    setFamilyNameVisibility(
      FieldsEnum.Coowners1FamilyName,
      FormsEnum.CalculationForm,
      stringifyPesel(pesel),
      isValidPesel
    );

    if (isFromRenewal) {
      if (checkHasDataChangedForRenewal(pesel, previousPesel)) {
        setDataOwnersChangedRenewal({
          ownerName: 'firstCoOwner',
          isChanged: true,
        });

        if (!initialRun && isValidPesel) {
          BusinessFunctionsService.setupFirstCoownerLicenseDates(initialRun);
          setNoDriverLicenseFieldsVisibility(DriverType.COOWNERS_1, initialRun);
        }
      }
    } else if (initialRun || isValidPesel) {
      BusinessFunctionsService.setupFirstCoownerLicenseDates(initialRun);
      setNoDriverLicenseFieldsVisibility(DriverType.COOWNERS_1, initialRun);
    }
  },

  onFirstCoownerFamilyNameChange() {
    setMainOwnerSelectionDictionary();
  },
};

export default firstCoownerDetails;
